const SMALL = '(max-width: 1279px)';
const MEDIUM = '(min-width: 1280px) and (max-width: 1365px)';
const DEFAULT = '(min-width: 1366px) and (max-width: 1919px)';
const LARGE = '(min-width: 1920px)';

export const SCREEN_TYPES = {
  SMALL: `${SMALL}`,
  MEDIUM: `${MEDIUM}`,
  DEFAULT: `${DEFAULT}`,
  LARGE: `${LARGE}`
};

export const CUSTOM_BREAKPOINTS = [
  { alias: 'small', mediaQuery: SCREEN_TYPES.SMALL },
  { alias: 'medium', mediaQuery: SCREEN_TYPES.MEDIUM },
  { alias: 'default', mediaQuery: SCREEN_TYPES.DEFAULT },
  { alias: 'large', mediaQuery: SCREEN_TYPES.LARGE }
];
